import {ListItem, ListItemProps} from '@genestack/ui';
import React from 'react';

/** Component for preloader in autocomplete */
export function PreloaderListItem(props: ListItemProps) {
    return <ListItem {...props} style={{paddingLeft: 8, paddingRight: 16}} />;
}
